<template>
  <div class="list-catalog">
    <component
      :is="navigationWrapper"
      v-for="(context, index) in contextList"
      :key="`${props.logger}_list_cell_${index}`"
      :cell-info="context"
      :index="index"
    >
      <template #clickable-cell>
        <component
          :is="getComponent(componentName)"
          :cell-info="context"
          :cell-type="cellType"
          :thumbnail-info="thumbnailInfo"
        />
      </template>
    </component>
  </div>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { useComponentLoader } from '@/common/use/useComponentLoader'
  import CellLoggerWrapperEditorPick from '@/components/model/cellWrapper/CellLoggerWrapperEditorPick.vue'
  import NavigationCellWrapper from '@/components/model/cellWrapper/NavigationCellWrapper.vue'

  const props = defineProps({
    contextList: {
      type: Array,
      default: () => [],
      required: true,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
    logger: {
      type: String,
      default: '',
    },
  })

  const { getComponent } = useComponentLoader()
  const componentName = computed(() => props.thumbnailInfo?.componentName ?? '')
  const cellType = computed(() => props.thumbnailInofo?.type ?? '')
  const navigationWrapper = computed(() => {
    switch (props.logger) {
      case 'editor-pick':
        return CellLoggerWrapperEditorPick
      default:
        return NavigationCellWrapper
    }
  })
</script>
